import React, { useEffect, useReducer, useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

const DemoModeInformation: React.FC<{}> = () => {
    const [show, setShow] = useState<boolean>(true);

    const { t } = useTranslation();
    const globalStyles = useAppSelector(getGlobalStyles);
    const containerCN = cn(styles.demo_mode_information_container, globalStyles.orientation);

    useEffect(() => {
        const show = ConfigLoader.urlParameters.isDemoPlay && ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).demoModeInformation ? true : false;
        setShow(show);
    }, []);

    return <>{show && <div className={containerCN}>{t('DEMO_MODE_INFORMATION')}</div>}</>;
};

export default DemoModeInformation;
